import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTour } from '@reactour/tour';

// components
import { General } from 'icons/untitledui';
import PrintConversation from 'eCoach/PrintConversation';
import { TopBar } from 'topBar/components/TopBar';

// styles
import { Step } from 'types/step';

interface ChatHeaderProps {
  steps: Step[];
  onBackClick?: () => void;
  showBackButton?: boolean;
}

export default function ChatHeader({
  steps,
  onBackClick,
  showBackButton = false,
}: ChatHeaderProps): JSX.Element {
  const { t } = useTranslation('pageEcoach');
  const [showPrintModal, setShowPrintModal] = useState(false);
  const { isOpen } = useTour();

  const handlePrintClick = () => {
    setShowPrintModal(true);
  };

  const menuItems =
    steps && steps.length > 0 && !isOpen
      ? [
          {
            label: t('ChatHeader.Print conversation'),
            onClick: handlePrintClick,
            icon: <General.Share03 size={20} />,
          },
        ]
      : [];

  return (
    <>
      <TopBar
        onBackClick={onBackClick}
        menuItems={menuItems}
        showBackButton={showBackButton}
        showOnDesktop={true}
        backButtonAriaLabel={t('Back to filters')}
        menuButtonAriaLabel={t('ChatHeader.Open menu')}
      />
      {steps && showPrintModal && (
        <PrintConversation
          steps={steps}
          isOpen={showPrintModal}
          onClose={() => setShowPrintModal(false)}
          onGeneratePDF={async () => setShowPrintModal(false)}
        />
      )}
    </>
  );
}
